import { render, staticRenderFns } from "./AnswerFeedBack.vue?vue&type=template&id=37f39a4b&scoped=true&"
import script from "./AnswerFeedBack.vue?vue&type=script&lang=js&"
export * from "./AnswerFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./AnswerFeedBack.vue?vue&type=style&index=0&id=37f39a4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f39a4b",
  null
  
)

component.options.__file = "AnswerFeedBack.vue"
export default component.exports